export const FETCH_PURCHASE_ORDERS_SUCCESS = 'fetch_purchase_orders_success'
export const ADD_PURCHASE_ORDERS_SUCCESS = 'add_purchase_orders_success'
export const FETCH_PURCHASE_ORDER_DETAILS_SUCCESS = 'fetch_purchase_order_details_success'
export const UPDATE_PURCHASE_ORDER_SUCCESS = 'update_purchase_order_success'
export const ADD_TRANSACTION_SUCCESS = 'add_transaction_success'
